module.exports = __webpack_public_path__ + "img/jituan.be8f7355.png";